import { SignupAction } from './actions';
import { SignupState } from './types';

const defaultState: SignupState = {};

export default function signupReducer(
  state = defaultState,
  action: SignupAction,
): SignupState {
  switch (action.type) {
    case 'SIGNUP__SELECT-DELIVERY-TYPE':
      return { ...state, deliveryType: action.deliveryType };
    case 'SIGNUP__SELECT-HOW-MANY-SITES':
      return { ...state, howManySites: action.howManySites };
    case 'SIGNUP__SELECT-PICKUP-ENABLED':
      return { ...state, pickupEnabled: action.pickupEnabled };
    case 'SIGNUP__SET-DELIVERY-FEE':
      return { ...state, deliveryFee: action.deliveryFee };
    case 'SIGNUP__SET-COUNTRY-TYPE':
      return { ...state, country: action.country };
    case 'SIGNUP__SET-DROP-OFF-REASON':
      return { ...state, dropOffReason: action.dropOffReason };
    case 'UPDATE_SIGNUP_BUSINESS_TYPE_STATE': {
      return {
        ...state,
        businessType: action.businessType,
      };
    }
    case 'SIGNUP__SET-LIMITED-COMPANY':
      return {
        ...state,
        businessDetails: { type: 'ltd', legalName: action.legalName },
      };
    case 'SIGNUP__SET-SOLE-TRADER':
      return {
        ...state,
        businessDetails: { type: 'sole-trader' },
      };
    case 'SIGNUP__SET-VAT-REGISTERED':
      return {
        ...state,
        vatDetails: { registered: true, vatNumber: action.vatNumber },
      };
    case 'SIGNUP__SET-VAT-NOT-REGISTERED':
      return {
        ...state,
        vatDetails: { registered: false },
      };
    case 'SIGNUP__UPDATE_ADDRESS_INFORMATION': {
      return {
        ...state,
        street: action.addressInfo.street,
      };
    }
    case 'SIGNUP__UPDATE_USER_INFORMATION': {
      return {
        ...state,
        ...(action.userInfo?.company && { company: action.userInfo?.company }),
        ...(action.userInfo?.email && { email: action.userInfo?.email }),
        ...(action.userInfo?.name && { name: action.userInfo?.name }),
        ...(action.userInfo?.surname && { surname: action.userInfo?.surname }),
      };
    }
    case 'SIGNUP__SET-LEAD-ID': {
      return {
        ...state,
        leadId: action.leadId,
      };
    }
    case 'SIGNUP__SET-HYGIENE-RATING-INFORMATION': {
      return {
        ...state,
        hasHygieneRating: action.hasHygieneRating,
        foodStandardAgencyId: action.foodStandardAgencyId,
        hasOwnKitchen: action.hasOwnKitchen,
        isFromSignupFlow: action.isFromSignupFlow,
      };
    }

    case 'SIGNUP__GET_LEAD_SUCCESS': {
      const {
        firstName: name,
        lastName: surname,
        deliveryMethod: deliveryType,
        numberOfBranches: howManySites,
        pickup: pickupEnabled,
        ...rest
      } = action.payload;

      return Object.assign({}, state, rest, {
        name,
        surname,
        deliveryType,
        howManySites,
        pickupEnabled,
      });
    }

    case 'SIGNUP__UPDATE_LEAD_SUCCESS':
      return {
        ...state,
        signupCheckpoint: action.payload.signupCheckpoint,
      };

    case 'SIGNUP__POST_CONTRACT_SUCCESS':
      return {
        ...state,
        hasAgreementSignature: true,
      };

    default:
      return state;
  }
}
